export default "__VITE_ASSET__zadYusjy__"